import './components/svg'
import bxSlider from 'bxslider/dist/jquery.bxslider.min'
import 'is-in-viewport'

let isScrolling = false
$(() => {

    $('.carousel').bxSlider({
        mode: 'fade',
        controls: false,
        auto: true,
        pause: 5000,
        preventDefaultSwipeX: false,
        preventDefaultSwipeY: false
    });
    
    $('.nav-opener').on('click', () => {
        $('body').toggleClass('nav-opened');
    })

    $('.language>span').on('click', (e) => {
        $(e.currentTarget).toggleClass('active');
        $('.language ul').toggleClass('visible');
    })

    jQuery(document).mouseup(function(e) {
        var container = jQuery('.language ul');

        if (e.target.className !== "language" && !jQuery(e.target).hasClass('active')) {
            container.removeClass('visible')
            $('.language>span').removeClass('active')
        }
    });
    scroller()
})

$(window).scroll(() => {
    if (typeof videoPlayer !== 'undefined') {
        if ($('#player:in-viewport').length && !isScrolling && typeof videoPlayer !== 'undefined') {
            videoPlayer.playVideo()
        } else {
            if (typeof videoPlayer.pauseVideo !== 'undefined') {
                videoPlayer.pauseVideo()
            }
        }
    }
})

const scroller = () => {
    const scrollLink = $('.js-scroller')
    
    scrollLink.each((index, item) => {
        $(item).on('click', (e) => {
            e.preventDefault()
            isScrolling = true
            $('.js-scroller').parent().removeClass('active')
            $(item).parent().addClass('active')
            $('body').removeClass('nav-opened');
            $('html, body').animate({
                scrollTop: $(`[data-container="${$(item).data('section')}"]`).offset().top
            }, 700, () => {
                isScrolling = false
            })
        })
    })
}